import { normalizeEvents, visibleEvents, type EventInfo } from "@greg-chick/shared";
import { fetchPublishedFirst } from "../lib/apiBase";

/**
 * 행사 일정 로드 — **관리자 게시본(엣지) 우선 → 정적 파일 폴백**(맵·굿즈와 동일 패턴).
 * 게시본이 있으면 운영자가 관리자에서 바꾼 일정이 즉시 반영되고, 서버가 없으면 정적으로 동작(불변식 3).
 *
 * ## 🔴 거르는 자리는 여기 하나다
 * 아이 화면에서 행사를 보는 곳은 셋이다 — 랜딩 배너·마을 이야기·행사 무대. 그런데 셋 다
 * 이 함수 하나를 거쳐서 받는다. 그래서 **여기서 한 번 거르면 세 곳이 같이 맞는다.**
 * 화면마다 다시 거르면 반드시 한 곳을 빠뜨리고, "배너에선 숨겼는데 마을 이야기엔 그대로"가 된다.
 *
 * 관리자는 이 통로를 안 쓴다(`/admin/events` 를 직접 읽는다) — 숨긴 행사도 편집할 수 있어야 하니까.
 */
/**
 * 🎪 행사 목록 — **못 받았는지까지** 돌려준다.
 *
 * 🔴 「예정된 행사가 아직 없어요」는 **진짜로 없을 때**만 할 수 있는 말이다.
 * 행사 당일 엣지가 흔들리면 무대에 모인 사람들이 전부 그 글을 본다.
 */
export async function loadEventsEx(): Promise<{ events: EventInfo[]; offline: boolean }> {
  const data = await fetchPublishedFirst("/api/events", "/content/events.json");
  if (!data) return { events: [], offline: true };
  return { events: visibleEvents(normalizeEvents(data)), offline: false };
}

/** 행사 목록. 왜 비었는지까지 필요하면 `loadEventsEx`. */
export async function loadEvents(): Promise<EventInfo[]> {
  return (await loadEventsEx()).events;
}
